import { build } from './build-info';
import { Environment } from './environment.type';

export const environment: Environment = {
    build,
    stage: 'production',
    LOGIN_URL: 'https://login.bannerflow.com',
    CLIENT_ID: 'w1DxVWPpJ0ICcqipPA3x6mtE2VF9dzy3',
    API_URLS: ['https://api.bannerflow.com/agent-bff'],
    AGENT_BFF_URL: 'https://api.bannerflow.com/agent-bff',
    AGENT_NAME: 'bannerflow-demo-agent'
};
